export const SHARE_USER_EMAIL_PLACEHOLDER = '_SHARE_LINK_';
